import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const Theses = () => {
  console.log('🔍 Theses: Component is being called!');
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  console.log('🔍 Theses: Component rendered');
  console.log('🔍 Theses: Current URL:', window.location.href);
  console.log('🔍 Theses: Current pathname:', window.location.pathname);

  // Mock data for demonstration
  const mockTheses = [
    {
      id: 1,
      title: "Intelligence Artificielle et Apprentissage Automatique",
      author: "Dr. Ahmed Benali",
      university: "Université des Sciences et de la Technologie Houari Boumediene",
      year: 2023,
      abstract: "Cette thèse explore les nouvelles approches en intelligence artificielle...",
      keywords: ["IA", "Machine Learning", "Deep Learning", "Algorithmes"],
      pdfUrl: "#"
    },
    {
      id: 2,
      title: "Systèmes de Gestion de Base de Données Distribuées",
      author: "Dr. Fatima Zohra Khelifi",
      university: "Université de Constantine 1",
      year: 2022,
      abstract: "Recherche sur l'optimisation des performances des bases de données...",
      keywords: ["Bases de données", "Distribué", "Performance", "Optimisation"],
      pdfUrl: "#"
    },
    {
      id: 3,
      title: "Cybersécurité et Protection des Données",
      author: "Dr. Mohamed Cherif",
      university: "École Nationale Supérieure d'Informatique",
      year: 2024,
      abstract: "Étude des menaces cybernétiques et méthodes de protection...",
      keywords: ["Cybersécurité", "Sécurité", "Protection", "Cryptographie"],
      pdfUrl: "#"
    }
  ];

  const [theses, setTheses] = useState(mockTheses);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedUniversity, setSelectedUniversity] = useState('');

  useEffect(() => {
    console.log('🔍 Theses: useEffect triggered');
    console.log('🔍 Theses: Component mounted successfully');
    console.log('🔍 Theses: Mock theses count:', mockTheses.length);
  }, []);

  const universities = [
    "Université des Sciences et de la Technologie Houari Boumediene",
    "Université de Constantine 1",
    "École Nationale Supérieure d'Informatique",
    "Université d'Alger 1",
    "Université de Tlemcen"
  ];

  const years = [2024, 2023, 2022, 2021, 2020];

  const filteredTheses = theses.filter(thesis => {
    const matchesSearch = thesis.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         thesis.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         thesis.abstract.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         thesis.keywords.some(keyword => keyword.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesYear = !selectedYear || thesis.year === parseInt(selectedYear);
    const matchesUniversity = !selectedUniversity || thesis.university === selectedUniversity;

    return matchesSearch && matchesYear && matchesUniversity;
  });

  return (
    <div className="theses-container">
      <div className="container mt-4">
        {/* Header Section */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="theses-header text-center">
              <h1 className="display-4 mb-3">
                <i className="fas fa-graduation-cap me-3"></i>
                Thèses de Doctorat CERIST
              </h1>
              <p className="lead" style={{color: 'white'}}>
                Découvrez les dernières recherches et contributions scientifiques de nos doctorants
              </p>
            </div>
          </div>
        </div>

        {/* Search and Filter Section */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="search-filters-card">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="search-box">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="fas fa-search"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher par titre, auteur, mots-clés..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="">Toutes les années</option>
                    {years.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <select
                    className="form-select"
                    value={selectedUniversity}
                    onChange={(e) => setSelectedUniversity(e.target.value)}
                  >
                    <option value="">Toutes les universités</option>
                    {universities.map(uni => (
                      <option key={uni} value={uni}>{uni}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results Count */}
        <div className="row mb-3">
          <div className="col-12">
            <p className="text-muted">
              <i className="fas fa-list me-2"></i>
              {filteredTheses.length} thèse{filteredTheses.length !== 1 ? 's' : ''} trouvée{filteredTheses.length !== 1 ? 's' : ''}
            </p>
          </div>
        </div>

        {/* Theses Grid */}
        <div className="row">
          {filteredTheses.map(thesis => (
            <div key={thesis.id} className="col-lg-6 col-xl-4 mb-4">
              <div className="thesis-card">
                <div className="thesis-card-header">
                  <h5 className="thesis-title">{thesis.title}</h5>
                  <div className="thesis-meta">
                    <span className="thesis-year badge bg-primary">{thesis.year}</span>
                  </div>
                </div>
                
                <div className="thesis-card-body">
                  <div className="thesis-author">
                    <i className="fas fa-user me-2"></i>
                    <strong>{thesis.author}</strong>
                  </div>
                  
                  <div className="thesis-university">
                    <i className="fas fa-university me-2"></i>
                    {thesis.university}
                  </div>
                  
                  <div className="thesis-abstract">
                    <p>{thesis.abstract}</p>
                  </div>
                  
                  <div className="thesis-keywords">
                    {thesis.keywords.map((keyword, index) => (
                      <span key={index} className="keyword-tag">
                        {keyword}
                      </span>
                    ))}
                  </div>
                </div>
                
                <div className="thesis-card-footer">
                  <button className="btn btn-outline-primary btn-sm me-2">
                    <i className="fas fa-eye me-1"></i>
                    Voir détails
                  </button>
                  <button className="btn btn-primary btn-sm">
                    <i className="fas fa-download me-1"></i>
                    Télécharger PDF
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredTheses.length === 0 && (
          <div className="row">
            <div className="col-12">
              <div className="empty-state text-center py-5">
                <i className="fas fa-search fa-3x text-muted mb-3"></i>
                <h4>Aucune thèse trouvée</h4>
                <p className="text-muted">
                  Essayez de modifier vos critères de recherche ou de filtres
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Coming Soon Notice */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="alert alert-info coming-soon-alert">
              <h5><i className="fas fa-info-circle me-2"></i>{t('comingSoon.title')}</h5>
              <p className="mb-0">
                {t('comingSoon.thesesDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theses;
